export const sslProductReducer = (state, action) => {
  switch (action.type) {
    case "SET_PRODUCT_DETAIL":
      return {
        ...state,
        price: action.payload.price,
        productDetails: action.payload.details,
      };
    case "SET_SELECTED_SSL_DROPDOWN":
      return {
        ...state,
        selectedSSL: action.payload,
      };
    case "ADD_CUSTOMFIELD_VALUE":
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          customfieldvalue: action.payload,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
